import { mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';

export default {
	data() {
		return {
			nativeSelectTheme: null
		};
	},
	props: {
		select: {
			type: Function,
			required
		}
	},
	components: {
		VueSelect,
		VueSelectOption
	},
	computed: {
		...mapState('newsModule', ['technicalError', 'loading', 'newsList', 'tags', 'selectedTag', 'allThemeTag'])
	},
	watch: {
		selectedTag(newValue) {
			this.nativeSelectTheme = newValue.tag;
		}
	}
};
